// Mobile menu toggle
const toggle = document.querySelector(".menu-toggle");
const nav = document.querySelector(".nav");
if (toggle && nav) {
  toggle.addEventListener("click", () => {
    nav.classList.toggle("is-open");
    const open = nav.classList.contains("is-open");
    toggle.setAttribute("aria-expanded", String(open));
  });
}

// Header subtle shadow on scroll
const header = document.querySelector(".site-header");
if (header) {
  const onScroll = () => {
    if (window.scrollY > 8) header.classList.add("is-scrolled");
    else header.classList.remove("is-scrolled");
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

// Reusable full-screen image zoom viewer (used by product gallery + carousel lightbox)
(function () {
  var zv = document.querySelector("[data-zoom-viewer]");
  if (!zv) return;
  var zImg = zv.querySelector("[data-zoom-img]");
  var zClose = zv.querySelector("[data-zoom-close]");
  var lastFocus = null;
  function open(src, alt) {
    if (!src) return;
    zImg.src = src;
    zImg.alt = alt || "";
    zImg.classList.remove("is-zoomed");
    zImg.style.transform = "";
    zv.hidden = false;
    document.body.style.overflow = "hidden";
    lastFocus = document.activeElement;
    if (zClose) zClose.focus();
  }
  function close() {
    zv.hidden = true;
    document.body.style.overflow = "";
    zImg.classList.remove("is-zoomed");
    zImg.style.transform = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  // Keep Tab inside the dialog while it is open
  zv.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var focusables = zv.querySelectorAll("button, [href], img[tabindex]");
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // Open from any element carrying data-zoom-src
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-zoom-src]");
    if (!t) return;
    e.preventDefault();
    var alt = t.getAttribute("alt") || (t.querySelector("img") && t.querySelector("img").alt);
    open(t.getAttribute("data-zoom-src"), alt);
  });
  function pan(e) {
    if (!zImg.classList.contains("is-zoomed")) return;
    var p = e.touches && e.touches[0] ? e.touches[0] : e;
    var r = zImg.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, ((p.clientX - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((p.clientY - r.top) / r.height) * 100));
    zImg.style.transformOrigin = x + "% " + y + "%";
    zImg.style.transform = "scale(2.4)";
  }
  zImg.addEventListener("click", function (e) {
    e.stopPropagation();
    if (zImg.classList.toggle("is-zoomed")) pan(e);
    else zImg.style.transform = "";
  });
  zImg.addEventListener("mousemove", pan);
  zImg.addEventListener("touchmove", function (e) { if (zImg.classList.contains("is-zoomed")) { e.preventDefault(); pan(e); } }, { passive: false });
  zv.addEventListener("click", function (e) { if (e.target === zv) close(); });
  zv.querySelector("[data-zoom-close]").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !zv.hidden) close(); });
})();

// Product gallery — swipeable slide track with thumbnails, arrows, dots, counter.
// Mobile swipes the track natively (scroll-snap); thumbnails/dots/arrows jump to a
// slide; swiping keeps the active thumb/dot/counter in sync. Tap (not swipe) still
// opens the zoom viewer via the [data-zoom-src] on each slide image.
(function () {
  var gallery = document.querySelector("[data-pdp-gallery]");
  if (!gallery) return;
  var track = gallery.querySelector("[data-pdp-slides]");
  var slides = gallery.querySelectorAll(".pdp__slide");
  if (!track || slides.length === 0) return;
  var thumbs = document.querySelectorAll("[data-pdp-thumb]");
  var dots = gallery.querySelectorAll("[data-pdp-dot]");
  var counter = gallery.querySelector("[data-pdp-counter]");
  var prev = gallery.querySelector("[data-pdp-prev]");
  var next = gallery.querySelector("[data-pdp-next]");
  var current = 0;

  function setActive(i) {
    current = i;
    thumbs.forEach(function (t, idx) { t.classList.toggle("is-active", idx === i); });
    dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
    if (counter) counter.textContent = (i + 1) + " / " + slides.length;
  }
  function goTo(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: "smooth" });
    setActive(i);
  }

  var raf;
  track.addEventListener("scroll", function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      if (idx !== current) setActive(idx);
    });
  });
  thumbs.forEach(function (t, idx) { t.addEventListener("click", function () { goTo(idx); }); });
  dots.forEach(function (d) { d.addEventListener("click", function () { goTo(parseInt(d.getAttribute("data-i"), 10)); }); });
  if (prev) prev.addEventListener("click", function () { goTo(current - 1); });
  if (next) next.addEventListener("click", function () { goTo(current + 1); });

  // Distinguish a swipe from a tap so a swipe never triggers the zoom viewer.
  var startX = 0, moved = false;
  track.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; moved = false; }, { passive: true });
  track.addEventListener("touchmove", function (e) { if (Math.abs(e.touches[0].clientX - startX) > 8) moved = true; }, { passive: true });
  track.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
})();

// Sticky mobile add-to-cart — appears once the buy button scrolls out of view,
// hides again while the footer is on screen so nothing stays covered.
(function () {
  var bar = document.querySelector("[data-sticky-atc]");
  var addBtn = document.querySelector("[data-pdp-add]");
  if (!bar || !addBtn || !("IntersectionObserver" in window)) return;
  bar.hidden = false;
  var pastBuyBox = false, footerInView = false;
  function update() {
    bar.classList.toggle("is-visible", pastBuyBox && !footerInView);
  }
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    pastBuyBox = e.boundingClientRect.top < 0 && !e.isIntersecting;
    update();
  }, { threshold: 0 }).observe(addBtn);
  var footer = document.querySelector(".site-footer");
  if (footer) {
    new IntersectionObserver(function (entries) {
      footerInView = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(footer);
  }
})();

// Mini-cart drawer + ajax cart (KoriqoCart).
// Adds to cart without a full-page redirect, opens a slide-out drawer, and keeps
// the header badge / quantities / subtotal in sync from /cart.js. Custom-design
// (SimpliMFG) line items keep their snapshot image + Edit Design link, and all
// line mutations go through /cart/change.js BY KEY so those properties survive.
(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;
  var CFG = window.KORIQO_CART || {};
  var cartUrl = CFG.cartUrl || "/cart";
  var linesEl = drawer.querySelector("[data-cart-lines]");
  var emptyEl = drawer.querySelector("[data-cart-empty]");
  var footEl = drawer.querySelector("[data-cart-foot]");
  var subtotalEl = drawer.querySelector("[data-cart-subtotal]");
  var panel = drawer.querySelector(".cart-drawer__panel");
  var lastFocus = null;
  var busy = false;

  function money(cents) {
    var fmt = CFG.money || "${{amount}}";
    function grp(dec) {
      var v = (cents / 100).toFixed(dec).split(".");
      v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return v.join(".");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, tok) {
      if (tok === "amount_no_decimals") return grp(0);
      if (tok === "amount_with_comma_separator") return (cents / 100).toFixed(2).replace(".", ",");
      if (tok === "amount_no_decimals_with_comma_separator") return grp(0).replace(/,/g, ".");
      return grp(2);
    });
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function lineHTML(item) {
    var props = item.properties || {};
    var customImg = props["_Customization_Snapshot"] || props["Print Ready Design"];
    var imgSrc = customImg || item.image || "";
    var img = imgSrc
      ? '<img class="cart-line__img" src="' + esc(imgSrc) + '" alt="" width="72" height="72" loading="lazy" />'
      : '<div class="cart-line__img cart-line__img--blank"></div>';

    var variant = "";
    if (item.variant_title && item.variant_title !== "Default Title") {
      variant += '<div class="cart-line__variant">' + esc(item.variant_title) + "</div>";
    }
    if (props["Size"]) {
      variant += '<div class="cart-line__variant">' + esc(props["Size"]) + "</div>";
    }

    var edit = "";
    if (props["_Design_State_ID"]) {
      var base = (item.url || "").split("?")[0];
      var href = base + "?design_state_id=" + encodeURIComponent(props["_Design_State_ID"]) +
        "&edit_line_item=" + encodeURIComponent(item.key);
      edit = '<a class="cart-line__edit" href="' + esc(href) + '">Edit design</a>';
    }

    return '<li class="cart-line" data-key="' + esc(item.key) + '">' +
      '<a class="cart-line__thumb" href="' + esc(item.url) + '">' + img + "</a>" +
      '<div class="cart-line__info">' +
        '<a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + "</a>" +
        variant + edit +
        '<div class="cart-line__row">' +
          '<div class="cart-line__qty" role="group" aria-label="Quantity">' +
            '<button type="button" class="cart-line__step" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="cart-line__count" aria-live="polite">' + item.quantity + "</span>" +
            '<button type="button" class="cart-line__step" data-step="1" aria-label="Increase quantity">+</button>' +
          "</div>" +
          '<span class="cart-line__price">' + money(item.final_line_price) + "</span>" +
        "</div>" +
        '<button type="button" class="cart-line__remove" data-remove aria-label="Remove ' + esc(item.product_title) + '">Remove</button>' +
      "</div>" +
    "</li>";
  }

  function updateBadge(count) {
    var btn = document.querySelector(".cart-btn");
    if (!btn) return;
    var badge = btn.querySelector(".cart-count");
    if (count > 0) {
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "cart-count";
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function render(state) {
    updateBadge(state.item_count);
    if (state.item_count === 0) {
      linesEl.innerHTML = "";
      linesEl.hidden = true;
      if (footEl) footEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    linesEl.hidden = false;
    linesEl.innerHTML = state.items.map(lineHTML).join("");
    if (footEl) footEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(state.total_price);
  }

  function getState() {
    return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function open() {
    drawer.hidden = false;
    // force reflow so the CSS transition runs
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    lastFocus = document.activeElement;
    var closeBtn = drawer.querySelector(".cart-drawer__close");
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    var onEnd = function () {
      drawer.hidden = true;
      drawer.removeEventListener("transitionend", onEnd);
    };
    drawer.addEventListener("transitionend", onEnd);
    // fallback if no transition fires
    setTimeout(function () { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openWithState() {
    getState().then(render).then(open).catch(function () { window.location = cartUrl; });
  }

  function addItem(id, qty, props) {
    if (busy) return;
    busy = true;
    var item = { id: id, quantity: qty || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    fetch(cartUrl.replace(/\/cart$/, "") + "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return getState(); })
      .then(function (state) { render(state); open(); })
      .catch(function () { window.location = cartUrl; })
      .then(function () { busy = false; });
  }

  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    fetch(cartUrl.replace(/\/cart$/, "") + "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error("change failed"); return r.json(); })
      .then(render)
      .catch(function () { window.location = cartUrl; })
      .then(function () { busy = false; });
  }

  // Intercept the PDP add-to-cart form (also covers the sticky bar, which submits form="product-form").
  var pform = document.getElementById("product-form");
  if (pform) {
    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = new FormData(pform);
      var id = data.get("id");
      var qty = parseInt(data.get("quantity"), 10) || 1;
      var props = {};
      data.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v) props[m[1]] = v;
      });
      if (id) addItem(id, qty, props); else window.location = cartUrl;
    });
  }

  // Header cart icon opens the drawer instead of navigating (falls back to /cart if JS fails).
  var cartBtn = document.querySelector(".cart-btn");
  if (cartBtn) {
    cartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      openWithState();
    });
  }

  // Close controls.
  drawer.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]")) close();
  });
  document.addEventListener("keydown", function (e) {
    if (!drawer.classList.contains("is-open")) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key === "Tab") {
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Quantity steppers + remove (delegated).
  linesEl.addEventListener("click", function (e) {
    var line = e.target.closest(".cart-line");
    if (!line) return;
    var key = line.getAttribute("data-key");
    if (e.target.closest("[data-remove]")) { changeLine(key, 0); return; }
    var step = e.target.closest(".cart-line__step");
    if (step) {
      var delta = parseInt(step.getAttribute("data-step"), 10);
      var cur = parseInt(line.querySelector(".cart-line__count").textContent, 10) || 1;
      var next = Math.max(0, cur + delta);
      changeLine(key, next);
    }
  });
})();
